import APIManager from 'modules/common/apiManager';
var instance = null;

class APIHandler {
  constructor(tData) {
    if (instance) {
      return instance;
    }
    this.mAPI = new APIManager();
    instance = this;
  }
  clearStorage() {
    this.mAPI.clearStorage();
  }
  updateUrl(url, tenantId) {
    this.mAPI.updateUrl(url, tenantId);
  }
  getCurrentUser() {
    var _this = this;
    return new Promise((resolve, reject) => {
      _this.mAPI.sendGetAPI(
        `auth/profile`,
        data => {
          if (data) {
            resolve(data);
          }
        },
        (error, data) => {
          resolve(null);
        },
        'private'
      );
    });
  }
  getCurrentUserAdmin() {
    var _this = this;
    return new Promise((resolve, reject) => {
      _this.mAPI.sendGetAPI(
        `auth/profile`,
        data => {
          if (data) {
            resolve(data);
          }
        },
        (error, data) => {
          resolve(null);
        },
        'public'
      );
    });
  }
  getCompany(companyName) {
    var _this = this;
    return new Promise((resolve, reject) => {
      _this.mAPI.sendGetAPI(
        `company/${companyName}`,
        data => {
          if (data) {
            resolve(data);
          }
        },
        (error, data) => {
          resolve(null);
        },
        'public'
      );
    });
  }
}

export default APIHandler;



// WEBPACK FOOTER //
// ./src/modules/common/dataset/api.js